import type { ReactNode } from 'react';

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function EmptyState({ title, description, action }: EmptyStateProps) {
  return (
    <div className='bg-white rounded-2xl p-8 shadow-card-sm text-center'>
      <h3 className='text-apple-near-black font-semibold text-[1.0625rem]'>{title}</h3>
      {description ? <p className='text-apple-gray text-[0.9375rem] mt-2'>{description}</p> : null}
      {action ? <div className='mt-5 flex justify-center'>{action}</div> : null}
    </div>
  );
}
